<script setup lang="ts">
interface Props {
  urlImage: string;
}
const props = defineProps<Props>();

const emits = defineEmits<{ handleDeleteImage: [] }>();

const getImageName = () => {
  const parts = props.urlImage.split('/');
  return parts[parts.length - 1];
};
</script>
<template>
  <div class="container">
    <div class="image-view">
      <img class="image-preview" :src="urlImage" alt="preview" />
    </div>
    <p class="image-name">{{ getImageName() }}</p>
    <div @click="emits('handleDeleteImage')" class="container-button-close">
      <div class="button-close"><i class="pi pi-times"></i></div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.container {
  padding: 1rem;
  border: 1px solid #dee2e6;
  border-radius: 6px;
  gap: 0.5rem;
  margin-bottom: 0;
}
.image-view {
  display: flex;
  align-items: center;
  margin-bottom: 0.5rem;
}
.image-preview {
  width: 100%;
  flex-shrink: 0;
}
.image-name {
  width: 100%;
  word-break: break-all;
}
.container-button-close {
  margin-left: auto;
}
.button-close {
  background-color: transparent;
  color: #ef4444;
  border-color: transparent;
  border-radius: 50%;
  height: 3rem;
  display: flex;
  margin: auto;
  align-items: center;
  width: 3rem;
  justify-content: center;
  &:hover {
    cursor: pointer;
    background: rgba(239, 68, 68, 0.04);
    border-color: transparent;
  }
}
</style>
